import { DashboardService } from '../../../../../../../services';
import SupplyChainSummaryProject from '../../../../../../../components/dashboards/SupplyChainSummaryProject';

const supplyChainCallback = (itemToFocus, activeSources) => {
  return DashboardService.getCaddSupplyChainMap(itemToFocus, activeSources);
}

export const SupplyChain = ({
  data = {},
  selectedProject = null,
  projectData = null,
  user = null,
  sidebarCollapsed = false,
  ...props
}) => (
  <SupplyChainSummaryProject
    data={data}
    selectedProject={selectedProject}
    projectData={projectData}
    datastakeId={user?.company?.userId}
    supplyChainMapCallback={supplyChainCallback}
    sidebarCollapsed={sidebarCollapsed}
    user={user}
    {...props}
  />
);
